import React from "react";
import { getTeamColors } from "../utils/badgeColors";

/**
 * The team currently holding a task.
 *
 * A task with no team is not the same as a task whose team is unknown — it is
 * one the backfill could not attribute, and only a super admin can see it to
 * put it right. Saying "No team" plainly is what gets it noticed and fixed.
 */
const TeamBadge = ({ name, short, size = "sm" }) => {
  const label = name || short || "No team";
  const { bg, text } = getTeamColors(name || short);
  const isUnset = !name && !short;

  return (
    <span
      className="badge rounded-pill"
      title={isUnset ? "This task has no team yet" : label}
      style={{
        backgroundColor: bg,
        color: text,
        fontWeight: 600,
        fontSize: size === "sm" ? "0.72rem" : "0.8rem",
        padding: size === "sm" ? "5px 10px" : "6px 12px",
        letterSpacing: "0.2px",
        border: isUnset ? "1px dashed #ced4da" : "none",
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
};

export default TeamBadge;
